'use client';

import { AuiIf, useAuiState, ThreadPrimitive } from '@assistant-ui/react';
import { type FC } from 'react';
import { useQuestionGate } from '@/billing/context';

export const ThreadFollowupSuggestions: FC = () => {
  const suggestions = useAuiState((s) => s.thread.suggestions);
  const { needsAuth, requestAuth } = useQuestionGate();
  return (
    <AuiIf
      condition={(s) => !s.thread.isEmpty && !s.thread.isRunning && s.thread.suggestions.length > 0}
    >
      <div className="aui-thread-followup-suggestions flex min-h-8 flex-wrap items-center justify-center gap-2 px-2">
        {suggestions.map((suggestion, idx) => (
          <ThreadPrimitive.Suggestion
            key={idx}
            className="aui-thread-followup-suggestion bg-card border-border/70 hover:bg-accent hover:border-control-border/60 shrink-0 rounded-full border px-3.5 py-1.5 text-sm shadow-[0_1px_2px_oklch(0_0_0/0.03)] transition-[color,background-color,border-color] duration-200 ease-(--ease-out-quart)"
            prompt={suggestion.prompt}
            method="replace"
            // Same auth gate as the composer/welcome suggestions: when signed
            // out under required auth, don't autoSend — fill the composer and
            // open the sign-in view so the pending send fires after sign-in.
            {...(needsAuth ? { onClick: requestAuth } : { autoSend: true })}
          >
            {suggestion.prompt}
          </ThreadPrimitive.Suggestion>
        ))}
      </div>
    </AuiIf>
  );
};
